import { PropsWithChildren } from "react";
import styled from "styled-components";

import { Box, Heading, Stack, Text } from "@vinomofo/components";
import { FooterLogo } from "./FooterLogo";
import { PaymentOptionLogos } from "../payment-option-logos";
import { WhiskymofoLogo } from "./WhiskymofoLogo";

const TextBlock = styled(Text)`
  > * {
    font-family: inherit;
    color: inherit;
    font-size: inherit;
  }

  ul {
    padding-left: 1.2em;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

const LegalsContent = ({
  heading,
  children,
}: PropsWithChildren<{ heading: string }>): JSX.Element => {
  return (
    <Box>
      <Heading as="h4" color="white" fontSize={[0, 2]}>
        {heading}
      </Heading>
      <TextBlock forwardedAs="div" color="dorianGray" fontSize={[0, 1]}>
        {children}
      </TextBlock>
    </Box>
  );
};

export const Legals = ({
  isWhiskymofo,
}: {
  isWhiskymofo?: boolean;
}): JSX.Element => {
  return (
    <Stack space={[4, 5]}>
      <Box
        display="grid"
        gridTemplateColumns={["1fr", "1fr", "1fr 1fr"]}
        gridGap="40px"
      >
        <LegalsContent heading="Hey Mofos!">
          {process.env.GATSBY_VM_MARKET === "AU" && (
            <>
              <p>Under the Liquor Control Reform Act 1998 it is an offence:</p>
              <ul>
                <li>
                  To supply alcohol to a person under the age of 18 years
                  (penalty exceeds $23,000).
                </li>
                <li>
                  For a person under the age of 18 years to purchase or receive
                  liquor (penalty exceeds $900)
                </li>
              </ul>
              <p>Liquor Licence No. 36300937</p>
            </>
          )}
          {process.env.GATSBY_VM_MARKET === "SG" && (
            <>
              <p>
                Under the Liquor Control (Supply and Consumption) Act 2015 it is
                an offence:
              </p>
              <ul>
                <li>
                  to supply any liquor to a person under the age of 18 years;
                </li>
                <li>
                  for a person under the age of 18 years to buy or attempt to
                  buy liquor
                </li>
              </ul>
              <p>
                No person under the age of 18 will be permitted to purchase wine
                from Vinomofo Asia Holdings Pte. Ltd.
              </p>
              <p>Name of Licensee: Vinomofo Asia Holdings Pte Ltd</p>
              <p>Class 4 Licence No. L/LL/034340/2024/P</p>
              <p>Class 3A Licence No. L/LL/034339/2024/P</p>
            </>
          )}
        </LegalsContent>
        <LegalsContent heading="Seriously">
          <p>
            At Vinomofo, we love our wine, but we like to also lead long and
            happy lives, and be good to the world and the people in it. We all
            try to drink responsibly, in moderation, and we really hope you do
            too.
          </p>
          <p>Don’t be that person…</p>
        </LegalsContent>
      </Box>
      {process.env.GATSBY_VM_MARKET === "AU" && (
        <>
          <LegalsContent heading="Acknowledgement of Country">
            <p>
              Vinomofo acknowledges the Traditional Custodians of the land on
              which we live and work, the Aboriginal and Torres Strait Islander
              peoples. We pay our respects to their Elders past, present, and
              emerging, and recognise their continuing connection to land,
              waters, and community.
            </p>
          </LegalsContent>
        </>
      )}
      <Box border="0" height="1px" backgroundColor="darkMofo" />
      <Box
        display={["block", "flex"]}
        alignItems="center"
        justifyContent="space-between"
      >
        <Box display="flex" alignItems="center" mr="20px">
          {isWhiskymofo ? (
            <WhiskymofoLogo />
          ) : (
            <>
              <FooterLogo />
              <Text color="text.normal" fontSize={[0, 1]} lineHeight="none">
                Nope, we don’t do the copyright &copy; thing.
              </Text>
            </>
          )}
        </Box>
        <Box mt={[30, 0]}>
          <PaymentOptionLogos />
        </Box>
      </Box>
    </Stack>
  );
};
